import React from "react";
import Select from "react-select";
import { FaCalendarAlt, FaPlus } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const customStyles = {
  control: (provided) => ({
    ...provided,
    backgroundColor: "black",
    borderColor: "#292524",
    color: "white",
    minHeight: "48px",
    fontSize: "1rem",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "white",
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "black",
    zIndex: '10'
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#1f2937" : "black",
    color: "white",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "white",
  }),
  input: (provided) => ({
    ...provided,
    color: "white",
  }),
};

export default function SessionModal({
  isOpen,
  onClose,
  onSave,
  mode = "create",
  data,
  onChange,
  variantOptions = [],
  typeOptions = [],
  locationOptions = [],
  onOpenLocationModal, // <-- add this prop
}) {
  const isEdit = mode === "edit";
  if (!isOpen) return null;
  return (

    <>
      <div className="fixed inset-0 z-[99999] bg-black bg-opacity-50 flex items-center justify-center px-3">
        <div className="border border-border bg-[#111] text-white rounded-lg md:p-8 p-4 w-full max-w-xl h-[80vh] overflow-auto scrollbar-hide relative">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-white text-2xl"
          >
            &times;
          </button>
          <h2 className="text-xl font-bold mb-5">
            {isEdit ? "Edit Session" : "Add New Session"}
          </h2>

          {/* Game Name */}
          <div className="mb-5">
            <label className="block text-sm font-medium mb-2">Game Name</label>
            <input
              type="text"
              name="gameName"
              placeholder="Enter game name"
              value={data.gameName || ""}
              onChange={onChange}
              className="w-full px-4 py-3 border border-border rounded bg-black text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Game Variant */}
          <div className="mb-5">
            <label className="block text-sm font-medium mb-2">Game</label>
            <Select
              options={variantOptions}
              styles={customStyles}
              value={variantOptions.find((opt) => opt.value === data.gameVarient)}
              onChange={(selectedOption) =>
                onChange({ target: { name: "gameVarient", value: selectedOption.value } })
              }
              placeholder="Select variant"
              classNamePrefix="react-select"
            />
          </div>

          {/* Game Type */}
          <div className="mb-5">
            <label className="block text-sm font-medium mb-2">Game Type</label>
            <Select
              options={typeOptions}
              styles={customStyles}
              value={typeOptions.find((opt) => opt.value === data.gameType)}
              onChange={(selectedOption) =>
                onChange({ target: { name: "gameType", value: selectedOption.value } })
              }
              placeholder="Select type"
              classNamePrefix="react-select"
            />
          </div>

          {/* Location */}
          <div className="mb-5">
            <label className=" text-sm font-medium mb-2 flex items-center justify-between">
              <span>Location</span>
              {!isEdit && (
                <button
                  type="button"
                  onClick={onOpenLocationModal}
                  className="text-blue-500 hover:underline text-sm"
                >
                  <FaPlus className="inline-block mr-1" />
                  Add Location
                </button>
              )

              }
            </label>
            <Select
              options={locationOptions}
              styles={customStyles}
              value={locationOptions.find((opt) => opt.value === data.gameLocation)}
              onChange={(selectedOption) =>
                onChange({ target: { name: "gameLocation", value: selectedOption.value } })
              }
              placeholder="Select location"
              classNamePrefix="react-select"
            />
          </div>

          {/* Buy-In */}
          <div className="mb-5">
            <label className="block text-sm font-medium mb-2">Buy-In ($)</label>
            <input
              type="number"
              name="buyIn"
              placeholder="Enter buy-in amount"
              value={data.buyIn || ""}
              onChange={onChange}
              className="w-full px-4 py-3 border border-border rounded bg-black text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Game Start */}
          <div className="mb-8">
            <label className="block text-sm font-medium mb-2">Game Start</label>
            <div className="relative">
              <FaCalendarAlt className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 z-[1]" />
              <DatePicker
                selected={data.gameStart ? new Date(data.gameStart) : null}
                onChange={(date) =>
                  onChange({
                    target: {
                      name: "gameStart",
                      value: date ? date.toISOString() : "",
                    },
                  })
                }
                showTimeSelect
                dateFormat="do MMMM yyyy HH:mm"
                placeholderText="Select date and time"
                className="w-full pl-10 pr-3 py-3 border border-border rounded bg-black text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                calendarClassName="custom-datepicker"
              />
            </div>
          </div>

          {/* Buttons */}
          <div className="flex justify-end gap-4 mt-3">
            <button
              onClick={onClose}
              className="px-6 py-2 border border-gray-600 rounded hover:bg-border"
            >
              Cancel
            </button>
            <button
              onClick={onSave}
              className="bg-secondary hover:opacity-75 px-4 py-2 rounded text-white flex items-center gap-2"
            >
              {isEdit ? "Save Changes" : "Add Session"}
            </button>
          </div>
        </div>
      </div>
    </>

  );
}
